// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"1163d98f","592":"3a5f62c4","952":"bc6760e2"}[chunkId] + ".chunk.js";
};